import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { ResourceTableService } from 'libs/ng-ui/src/lib/_services/resource-table.service';
import { CtxTableContentComponent } from '../content/content.component';
import { CtxTableToolbarComponent } from '../toolbar/toolbar.component';

/**
 * The table is a 'dumb-component' which only renders data stored in a service. It is important for us to specify that
 * the service is of the ResourceTableService type.
 *
 * A big takeaway from this approach is that the service must be passed through components as a whole with a type. Using dot notation
 * to pass parts of the service will most likely fail.
 *
 * Passing this service as a whole keeps our code DRY, and removes the requirement of having a TableComponent with business logic.
 * While this makes the implementation a bit complex and unusual, it benefits us by simplfying the process of scaling entities.
 */
@Component({
  selector: 'ctx-paginated-table',
  templateUrl: './paginated-table.component.html',
  standalone: true,
  imports: [CtxTableToolbarComponent, CtxTableContentComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CtxPaginatedTableComponent {
  @Input() resourceTableService: ResourceTableService;
}
